import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=70fdd891&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fdd891')) {
      api.createRecord('70fdd891', component.options)
    } else {
      api.reload('70fdd891', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=70fdd891&", function () {
      api.rerender('70fdd891', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/UpdateInfo/Company.vue"
export default component.exports